import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationSubscriptionChangePlanGet = {
    path: "/subscription/change-plan",
    method: ERouteHttpVerb.GET
};
export { routeLocationSubscriptionChangePlanGet };
